<template>
    <div class="item">
        <div class="row">
            <div class="col-12 col-sm-9 offset-sm-3">
                <h4 class="h2 title">
                    <a :href="url" target="_blank" v-if="url" v-html="title"/>
                    <span v-else v-html="title"/>
                </h4>
            </div>
            <div class="d-none d-sm-block col-sm-3">
                <a :href="url" target="_blank" class="image" :style="`background-image:url(${logo})`"
                   v-if="logo && url"/>
                <div class="image" :style="`background-image:url(${logo})`" v-else-if="logo"/>
            </div>
            <div class="col-12 col-sm-9">
                <div class="row" v-if="text">
                    <div class="col-12 col-md-10 col-xl-8">
                        <address v-if="address" class="address">
                            <div v-html="address"></div>
                            <a :href="url" target="_blank" v-if="url">Webseite</a>
                        </address>
                        <div v-html="text" class="text" v-if="text"></div>
                        <div class="branches">Branchen: <span v-for="category in categories">{{category.title}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'categories': Object,
            'url': String,
            'title': String,
            'text': String,
            'logo': String,
            'address': String,
            'index': Number
        }
    }
</script>